if (!customElements.get('wy-buy-now')) {
  customElements.define('wy-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const scope = this.closest('.shopify-section') || this.parentElement;
      scope.addEventListener('variant:selected', (event) => {
        if (event.target.closest('variant-picker')?.dataset.productId !== this.dataset.productId) return;
        this.querySelector('button').disabled = true;
        this.querySelector('button').setAttribute('aria-disabled', 'true');
        this.querySelector('[name="id"]').disabled = true;
      }, options);
      scope.addEventListener('variant:update', (event) => {
        if (String(event.detail.data.productId) !== this.dataset.productId) return;
        const variant = event.detail.resource;
        const available = Boolean(variant?.available);
        const input = this.querySelector('[name="id"]');
        const button = this.querySelector('button');
        input.value = variant?.id || '';
        input.disabled = !available;
        button.disabled = !available;
        button.setAttribute('aria-disabled', String(!available));
        button.textContent = available ? this.dataset.buyLabel : variant ? this.dataset.soldLabel : this.dataset.unavailableLabel;
      }, options);
      this.querySelector('form').addEventListener('submit', (event) => {
        if (this.querySelector('button').disabled || this.querySelector('[name="id"]').disabled) event.preventDefault();
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
